import { getCLS, getFCP, getFID, getLCP, getTTFB, Metric, ReportHandler } from 'web-vitals';
import logger from 'services/logger';

// Map of web vitals metric names and their human readable representations
const metricMap = new Map<string, string>([
  ['CLS', 'Cumulative layout shift'],
  ['FCP', 'First contentful paint'],
  ['FID', 'First input delay'],
  ['LCP', 'Largest contentful paint'],
  ['TTFB', 'Time to first byte'],
]);

/**
 * Log a web vitals metric
 *
 * @param {Metric} metric Target metric to log
 */
export const logWebVitals = (metric: Metric) => {
  const { name, value } = metric;
  const description = metricMap.get(name) ?? name;

  logger.debug('vitals', description, `(${value.toFixed(2)})`);
};

/**
 * Measure application performance
 *
 * @param {ReportHandler} handler Performance report handler
 * @see https://web.dev/vitals/
 * @see https://bit.ly/CRA-vitals
 */
export const reportWebVitals = (handler?: ReportHandler) => {
  if (!(handler instanceof Function)) {
    return;
  }

  // Measure cumulative layout shift (visual stability)
  getCLS(handler);

  // Measure first input delay (interactivity)
  getFID(handler);

  // Measure first contentful paint
  getFCP(handler);

  // Measure largest contentful paint (loading performance)
  getLCP(handler);

  // Measure time to first byte
  getTTFB(handler);
};
